/* eslint-disable max-len */
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getRevenueReports } from '@zero5/payment-api';

import { mapRevenueReports } from './mappings';
import { queryGroupName } from './queryGroupName';

type Response = ReturnType<typeof mapRevenueReports>;
type Params = {
  page?: number;
  take?: number;
  orderBy?: 'date' | 'permit' | 'event' | 'transient' | 'validation' | 'total';
  direction?: 'DESC' | 'ASC';
};

export const queryKey: QueryKey = 'revenueReports';

type Key = [typeof queryGroupName, typeof queryKey, Params];

const useRevenueReportsQuery = (
  params: Params,
  options?: UseQueryOptions<Response, unknown, Response, Key>,
) => {
  return useQuery<Response, unknown, Response, Key>(
    [queryGroupName, queryKey, params],
    async () => {
      const response = await getRevenueReports(params);

      return mapRevenueReports(response);
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: Infinity,
      ...options,
    },
  );
};

export default useRevenueReportsQuery;
